module.exports = __webpack_public_path__ + "static/media/graph.4cf95bf7.png";